/**
 * The subcategory description of the asset class.
 * - Tag: 1939
 * - FIX Specification type: int
 * - Mapped type: number
 * @readonly
 * @public
 */
export const AssetSubClass = Object.freeze({
    /** Single currency */
    SingleCurrency: 1,
    /** Cross currency */
    CrossCurrency: 2,
    /** Basket [for multi-currency] */
    Basket: 3,
    /** Single name */
    SingleName: 4,
    /** Credit index */
    CreditIndex: 5,
    /** Index tranche */
    IndexTranche: 6,
    /** Credit basket */
    CreditBasket: 7,
    /** Exotic */
    Exotic: 8,
    /** Common */
    Common: 9,
    /** Preferred */
    Preferred: 10,
    /** Equity index */
    EquityIndex: 11,
    /** Equity basket */
    EquityBasket: 12,
    /** Metals */
    Metals: 13,
    /** Bullion */
    Bullion: 14,
    /** Energy */
    Energy: 15,
    /** Commodity index */
    CommodityIndex: 16,
    /** Agricultural */
    Agricultural: 17,
    /** Environmental */
    Environmental: 18,
    /** Freight */
    Freight: 19,
    /** Government */
    Government: 20,
    /** Agency */
    Agency: 21,
    /** Corporate */
    Corporate: 22,
    /** Financing */
    Financing: 23,
    /** Money market */
    MoneyMarket: 24,
    /** Mortgage */
    Mortgage: 25,
    /** Municipal */
    Municipal: 26,
    /** Mutual fund */
    MutualFund: 27,
    /** Collective investment vehicle */
    CollectiveInvestmentVehicle: 28,
    InvestmentProgram: 29,
    SpecializedAccountProgram: 30,
    /** Term loan */
    TermLoan: 31,
    /** Bridge loan */
    BridgeLoan: 32,
    /** Letter of credit */
    LetterOfCredit: 33,
    /** Dividend index */
    DividendIndex: 34,
    /** Stock dividend */
    StockDividend: 35,
    /** Exchange traded fund */
    ExchangeTradedFund: 36,
    /** Volatility index */
    VolatilityIndex: 37,
    /** FX cross rates */
    FXCrossRates: 38,
    /** FX emerging markets */
    FXEmergingMarkets: 39,
    /** FX Majors */
    FXMajors: 40,
    /** Fertilizer */
    Fertilizer: 41,
    /** Industrial product */
    IndustrialProduct: 42,
    /** Inflation */
    Inflation: 43,
    /** Paper */
    Paper: 44,
    /** Polypropylene */
    Polypropylene: 45,
    /** Official economic statistics */
    OfficialEconomicStatistics: 46,
    OtherC10: 47,
    Other: 48,
} as const);

export type AssetSubClass = (typeof AssetSubClass)[keyof typeof AssetSubClass];
